import React from "react";
import TermsConditions from "@components/termsAndConditions";
import initialCall from "@helpers/initial-call";
import { GetStaticPropsContext } from "next";
import { GQLDomains } from "@gql/types/gql";
import { getKeyWordsForMetaTags } from "@lib/sharedUtils";
import { useQuery } from "@tanstack/react-query";
import MetaTags from "@components/shared/metaTags";
import Breadcrumb from "@components/shared/breadcrumb";
import { translate } from "@helpers/translationObjectFormatter";
import { ICustomDomain, TranslationsObject } from "@genericTypes/sharedTypes";
const TermsAndConditionsPage = () => {
    const { data: domainInfo } = useQuery<ICustomDomain, Error>({
        queryKey: ["domain"],
    });
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const arr = [
        {
            label: translate(translations, "several_general_breadcrumb_home"),
            link: "/",
            isActive: true,
            showOnMobile: true,
        },

        {
            label: translate(translations, "several_termsAndConditionsPage"),
            link: "",
            isActive: false,
            showOnMobile: true,
        },
    ];
    return (
        <>
            <MetaTags
                description={translate(
                    translations,
                    "several_privacyPolicyPage_meta_description",
                )}
                title={`${translate(
                    translations,
                    "several_termsAndConditionsPage",
                )} | Several.com`}
                keyWords={
                    getKeyWordsForMetaTags(
                        domainInfo?.domain as GQLDomains,
                    ) as string
                }
            />
            <section className="max-w-7xl mx-auto px-5">
                <Breadcrumb arr={arr} />
                <TermsConditions />
            </section>
        </>
    );
};

export const getStaticProps = async (ctx: GetStaticPropsContext) => {
    return await initialCall("TermsAndConditions", ctx);
};
export default TermsAndConditionsPage;
